import styled from 'styled-components'

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: white;
`

export const ArrowWrapper = styled.button`
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
  top: calc(50% - 40px);
  ${(props) => (props.right ? 'right: -50px;' : 'left: -50px;')}
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background-color: var(--cinza-medio);
  color: var(--cinza-escuro);
  border: 0;
  transition: all 300ms;
  &:hover {
    transform: scale(1.1);
    filter: brightness(0.85);
  }
`

export const CountImage = styled.text`
  padding: 5px 10px;
  margin-top: 5px;
  border-radius: 25px;
  border: 2px solid var(--azul-escuro);
  font-weight: 900;
  color: var(--azul-escuro);
`

export const Image = styled.img`
  background-color: transparent;
  width: 100%;
  object-fit: contain;
  border-radius: 5px;
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.15));
`

export const NoImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cinza-medio);
  color: var(--cinza-escuro);
  aspect-ratio: 1;
  width: 100%;
  border-radius: 5px;
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.15));
`

export const DeleteButton = styled.button`
  cursor: pointer;
  background-color: var(--cinza-muito-claro);
  color: var(--azul-escuro);
  display: flex;
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  transition: all 300ms;
  &:hover {
    background-color: var(--cinza-medio);
  }
`
